import script from "./Import.vue?vue&type=script&setup=true&lang=js"
export * from "./Import.vue?vue&type=script&setup=true&lang=js"

import "./Import.vue?vue&type=style&index=0&id=b0d32dae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d32dae"]])

export default __exports__